import styled from 'styled-components';

export const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.85);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10000;
	padding: 20px;
	box-sizing: border-box;
`;

export const ImageContainer = styled.div`
	position: relative;
	max-width: 90vw;
	max-height: 90vh;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Image = styled.img`
	max-width: 100%;
	max-height: 90vh;
	object-fit: contain;
	border-radius: 8px;
`;

export const CloseButton = styled.button`
	position: absolute;
	top: -40px;
	right: 0;
	background: none;
	border: none;
	cursor: pointer;
	padding: 8px;
	border-radius: 4px;
	color: ${({ theme }) => theme.gray[100]};
	transition: all 0.2s ease-in-out;
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		background-color: rgba(255, 255, 255, 0.1);
	}
`;

export const LoadingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 200px;
	min-height: 200px;
`;
